/**
 * Thin wrapper around Plausible's global `window.plausible()` so components
 * can fire named custom events without checking window/existence everywhere.
 *
 * Events wired across the app:
 *   - "Add To Cart"          — { product, category, price }
 *   - "Cart Add All"         — { source: 'recipe', recipe }
 *   - "Checkout Started"     — { items, total }
 *   - "Catalogue Downloaded" — { lang }
 *   - "Inquiry Submitted"    — { source, categories }
 *   - "Wholesale Applied"    — { businessName }
 *   - "Recipe Printed"       — { recipe }
 *
 * Plausible auto-tracks pageviews across SPA route changes when initialised
 * with `plausible.init()` (v2 script), so we don't need to push those ourselves.
 */
export function trackEvent(name, props) {
  if (typeof window === 'undefined') return;
  try {
    if (typeof window.plausible === 'function') {
      window.plausible(name, props ? { props } : undefined);
    }
  } catch (e) {
    // Analytics must never break the app
    if (process.env.NODE_ENV !== 'production') {
      console.warn('trackEvent failed:', e);
    }
  }
}
